import React, { useState } from "react";
import MainLeft from "./Main/MainLeft";
import MainFilter from "./Main/MainFilter";
import MainBody from "./Main/MainBody";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Paper,
  Button,
  TextField,
  Container,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";

const Main = ({
  responseFilmList,
  setResponseListChannels,
  setSendDataFilmListQueryFilter,
  getDataFilmList,
}) => {
  const rightTableData = Array.from({ length: 10 }, () =>
    Array.from({ length: 8 }, () => "Data")
  );
  // Данные для нижней левой таблицы с кнопками
  const leftBottomTableData = Array.from(
    { length: 5 },
    (_, i) => `Button ${i + 1}`
  );

  return (
    <Box sx={{ height: "90vh", display: "flex" }}>
      <MainLeft
        leftBottomTableData={leftBottomTableData}
        setResponseListChannels={setResponseListChannels}
        setSendDataFilmListQueryFilter={setSendDataFilmListQueryFilter}
        getDataFilmList={getDataFilmList}
      />

      <Box sx={{ width: "85%", display: "flex", flexDirection: "column" }}>
        {/* <MainFilter
          responseFilter={responseFilter}
          setSendDataFilmListQueryFilter={setSendDataFilmListQueryFilter}
          getDataFilmList={getDataFilmList}
        /> */}
        <MainBody
          rightTableData={rightTableData}
          responseFilmList={responseFilmList}
          getDataFilmList={getDataFilmList}
        />
      </Box>
    </Box>
  );
};

export default Main;
